import background from '../../assets/background.png'
import style from './style.module.css'

export default function Background(){
    return (
        <img className={style.background} src={background} alt="Background" />
    )
}